import { lazy } from 'react';

// project-imports
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';
import { Navigate } from 'react-router-dom';
import AuthGuard from '../layout/Auth/AuthGuard';

// render - basic component pages
const AdminManagment = Loadable(lazy(() => import('../sections/user-management/admin-management/AdminManagment')));

// ==============================|| COMPONENT ROUTING ||============================== //

const UserManagmentRoutes = {
  path: '/',
  element: <AuthGuard allowedRoles={['SUPER_ADMIN']}/>,
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'user-management',
          children: [
            {
              // This makes /menu automatically open /menu/categories
              index: true, 
              element: <Navigate to="/user-management/sub-admin" replace /> 
            },
            {
              path: 'sub-admin',
              element: <AdminManagment />
            }
          ]
        }
      ]
    }
  ]
};

export default UserManagmentRoutes;
